import React, { MouseEvent } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext';
import { useEntity } from '../../contexts/EntityContext';
import { useYear } from '../../contexts/YearContext';
import { useHistory } from 'react-router-dom';
import './UserDetailsPanel.css';

interface UserDetailsPanelProps {
    show: boolean;
    onHide: () => void;
}

const UserDetailsPanel: React.FC<UserDetailsPanelProps> = ({ show, onHide }) => {
    const { user, logout } = useAuth();
    const { setCurrentEntity } = useEntity();
    const { clearCurrentYear } = useYear();
    const history = useHistory();

    const handleLogout = async () => {
        try {
            // Clear all context states
            setCurrentEntity(null);
            clearCurrentYear();

            // Perform logout
            await logout();

            // Close the panel
            onHide();

            // Navigate to login page
            history.push('/login');
        } catch (error) {
            console.error('Logout error:', error);
            // Even if logout fails, clear local states and redirect
            setCurrentEntity(null);
            clearCurrentYear();
            onHide();
            history.push('/login');
        }
    };

    if (!show) return null;

    return (
        <div className="user-panel-overlay" onClick={onHide}>
            <Card className="user-panel" onClick={(e: MouseEvent) => e.stopPropagation()}>
                <Card.Body>
                    <div className="user-panel-header">
                        <h5 className="mb-3 text-primary">Detalhes do Usuário</h5>
                        <button className="close-button" onClick={onHide}>×</button>
                    </div>
                    {user && (
                        <div className="user-details">
                            <div className="user-info">
                                <i className="bi bi-person-circle user-icon"></i>
                                <div className="user-text">
                                    <strong>{user.name}</strong>
                                    <small className="text-muted d-block">{user.email}</small>
                                </div>
                            </div>
                            {user.su && (
                                <Button
                                    variant="primary"
                                    className="w-100 mb-3"
                                    onClick={() => {
                                        history.push('/admin');
                                        onHide();
                                    }}
                                >
                                    <i className="bi bi-gear me-2"></i>
                                    Administrador do Sistema
                                </Button>
                            )}
                            <Button
                                variant="secondary"
                                className="w-100"
                                onClick={handleLogout}
                            >
                                <i className="bi bi-box-arrow-right me-2"></i>
                                Sair do Sistema
                            </Button>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
};

export default UserDetailsPanel; 